module.exports = __webpack_public_path__ + "static/media/phone-white.5c80fb7d.svg";